// extracted by mini-css-extract-plugin
export default {"footer":"PHb4CjwojkMbpyM3ylHrcg==","confirmFooter":"lTXixbTkRcqRNzhcWYhgnQ==","button":"KutG8KiQCyE9VJriRB6+ug=="};